import Text from '../../../Text'
import { getSelectDropdownEntityListItenInfoStylesMods } from '../../Select.utils'

import * as styles from './SelectDropdownEntityListItemContentInfoText.module.css'

function SelectDropdownEntityListItemContentInfoText({
  className = styles.SelectDropdownEntityListItemContentInfoText,
  listExtraText,
  ref,
  textProps,
  value,
  ...restProps
}) {
  const { label } = value

  const textClassName = getSelectDropdownEntityListItenInfoStylesMods({
    ...restProps,
    className,
    styles,
  })

  return label ? (
    <Text {...textProps} className={textClassName} ref={ref}>
      {listExtraText}
      {label}
    </Text>
  ) : null
}

export default SelectDropdownEntityListItemContentInfoText
